module.exports = {
  DIESEL: 'diesel',
  GASOLINE: 'gasoline',
  ELECTRIC: 'electric',
  HYBRID: 'hybrid',
  GAS: 'gas',
};
